<template>
    <div class="card">
        <!-- <TabView @tab-change="handleTabChange"> -->
            <TabView>
            <TabPanel header="รายละเอียดข้อมูลเครื่องมือฯ">
                <report-equipment-detail></report-equipment-detail>
            </TabPanel>
            <!-- <TabPanel header="สรุปจำนวนเครื่องมือฯ">
                <report-equipment-amount></report-equipment-amount>
            </TabPanel> -->
            <TabPanel header="ประวัติการซ่อมบำรุง">
                <report-equipment-maintenance></report-equipment-maintenance>
            </TabPanel>
            <TabPanel header="ประวัติการยืม">
                <report-equipment-borrowing></report-equipment-borrowing>
            </TabPanel>
            <TabPanel header="ตรวจสอบ">
                <report-equipment-investigation></report-equipment-investigation>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
// import reportEquipmentAmount from './ReportEquipmentAmount';
import reportEquipmentDetail from './ReportEquipmentDetail';
import reportEquipmentMaintenance from './ReportEquipmentMaintenance';
import reportEquipmentBorrowing from './ReportEquipmentBorrowing';
import reportEquipmentInvestigation from './ReportEquipmentInvestigation';

export default {
    components: {
        // reportEquipmentAmount,
        reportEquipmentDetail,
        reportEquipmentMaintenance,
        reportEquipmentBorrowing,
        reportEquipmentInvestigation
    },
    data() {
      return{
          
      }    
    },

    watch:{

    },

    mounted(){
    },

    methods: {
        handleTabChange(newTab){
            console.log(newTab.tab.$vnode.componentOptions.propsData.header)
        }
    }
}
</script>